import { isProduction, DOMAIN } from '../libs/constants'
import Fetcher from './fetch'

const servicePrefix = isProduction ? '' : 'dev-'

export const INVALID_ID_TOKEN = 'INVALID_ID_TOKEN'

export function getServicePath(serviceName: string): string {
  return `/${servicePrefix}${serviceName}`
}

function createInstance({ withToken = false }: { withToken?: boolean }) {
  const instance = new Fetcher(DOMAIN, withToken)

  return instance
}

export const publicInstance = createInstance({ withToken: false })
export const authorizedInstance = createInstance({ withToken: true })
